import { CSSProperties, FC } from 'react';
import css from './style.module.css';

type Props = {
  style: CSSProperties;
};

export const Layout: FC<Props> = ({ style }) => (
  <span className={css.root} style={style} aria-hidden />
);
